import { Component, OnInit, ChangeDetectorRef, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToasterService } from 'angular2-toaster';
import axios from 'axios';
import { IMyDpOptions, MyDatePicker } from 'mydatepicker';
import {
  ACCESSIBLE_CHANNEL_TYPE_PLAYLIST,
  ENDPOINTS,
  USER_ROLES,
} from '../app.config';
import Utils from '../app.utilities';
import { CompanyService } from '../company.service';
import { TranslateService } from '@ngx-translate/core';

const utilities = new Utils();

@Component({
  selector: 'app-playlist-table',
  templateUrl: './playlist-table.component.html',
  styleUrls: ['./playlist-table.component.css'],
})
export class PlaylistTableComponent implements OnInit {
  searchChannels = [];
  channelsList = [];
  selectedChannels = [];
  dropdownSettings = {};
  router: Router;
  userRole: string;
  sub: any;
  companyId: string;
  companyName: string;
  playlistName: string;
  publishedDate: any;
  validityDate: any;
  isPublished: boolean;
  isAssetList: boolean;
  priority: any;
  allDay: boolean;
  errorFields: any;
  myDatePickerOptions: IMyDpOptions = {
    dateFormat: 'dd.mm.yyyy',
  };
  route: ActivatedRoute;
  fromHours: string;
  fromMinutes: string;
  toHours: string;
  toMinutes: string;
  disabledTimeChooser: boolean;

  playlists: any[];
  playlistsTotal: number;
  playlistsPerPage: number;
  totalPages: number;
  currentPage: number;
  gettingPlaylistsInProgress: boolean;
  companyService: CompanyService;
  filterChannels: any;
  toaster: ToasterService;
  filter: string;
  getPlaylistConfig: any;
  assetListFilter: string | null = 'null';
  @Input()
  hideFilters = false;

  // Messages
  playlist_added_successfully: string;
  error_adding_playlist: string;
  playlist_successfully_copied: string;
  error_playlist_copied: string;

  constructor(
    route: ActivatedRoute,
    companyService: CompanyService,
    toaster: ToasterService,
    router: Router,
    private translate: TranslateService,
    private changeDetector: ChangeDetectorRef,
  ) {
    this.router = router;
    this.route = route;
    this.companyService = companyService;
    this.toaster = toaster;
  }

  ngOnInit() {
    this.getPlaylistConfig = {
      perPage: 10,
      filtering: false,
      filteringBy: [],
      q: '',
      asset_list: null,
    };
    this.gettingPlaylistsInProgress = false;
    this.filterChannels = [];
    this.playlists = [];
    this.channelsList = [];
    this.selectedChannels = [];
    this.filter = '';
    this.disabledTimeChooser = false;
    this.errorFields = [];
    this.allDay = false;
    this.playlistName = '';
    this.isPublished = false;
    this.priority = 0;
    this.fromHours = '08';
    this.fromMinutes = '00';
    this.toHours = '18';
    this.toMinutes = '00';
    this.currentPage = 1;
    this.publishedDate = this.generateTodayDate();
    this.sub = this.route.params.subscribe(params => {
      this.companyId = params.companyId;
      this.companyService.setCompanyId(this.companyId);
      this.getUserInfo();
      this.getPlaylists();
      this.getChannels();
    });
    // Translations
    this.translate.stream('SHARED.SelectBox.select_channels').subscribe((res: string) => {
      this.dropdownSettings = {
        singleSelection: false,
        enableCheckAll: false,
        text: res,
        selectAllText: 'Select All',
        unSelectAllText: 'Remove All',
        enableSearchFilter: false,
        classes: 'item-separation c-token',
      };
    });

    this.translate.stream('SHARED.Messages.playlist_added_successfully').subscribe((res: string) => {
      this.playlist_added_successfully = res;
    });
    this.translate.stream('SHARED.Messages.error_adding_playlist').subscribe((res: string) => {
      this.error_adding_playlist = res;
    });
    this.translate.stream('SHARED.Messages.playlist_successfully_copied').subscribe((res: string) => {
      this.playlist_successfully_copied = res;
    });
    this.translate.stream('SHARED.Messages.error_playlist_copied').subscribe((res: string) => {
      this.error_playlist_copied = res;
    });
  }

  loadPlaylists(page, isDisabled) {
    if (!isDisabled && !this.gettingPlaylistsInProgress) {
      this.currentPage = page;
      this.getPlaylists();
    }
  }

  generatePages() {
    if (!this.totalPages) {
      return [];
    }
    const arr = [];
    for (let i = 0; i < this.totalPages; i++) {
      arr.push(i + 1);
    }
    return arr;
  }

  searchPlaylists() {
    this.currentPage = 1;
    this.getPlaylistConfig.filtering = true;
    this.getPlaylistConfig.q = this.filter;
    this.getPlaylists();
  }

  initPagingVars(response) {
    const _self = this;
    _self.playlistsTotal = parseInt(response.headers['total'], 10);
    _self.playlistsPerPage = parseInt(response.headers['per-page'], 10);
    _self.totalPages = Math.floor(
      _self.playlistsTotal % _self.playlistsPerPage,
    ) === 0
      ? _self.playlistsTotal / _self.playlistsPerPage
      : Math.floor(_self.playlistsTotal / _self.playlistsPerPage) + 1;
  }

  getPlaylists() {
    const _self = this;
    let initialUrl = '';

    if (
      this.getPlaylistConfig.filtering === true &&
      ( this.getPlaylistConfig.filteringBy.length ||
        this.getPlaylistConfig.q.length ||
        this.getPlaylistConfig.asset_list != null
      )
    ) {
      initialUrl = ENDPOINTS[
        _self.router.url.includes('company')
          ? 'DASHBOARD_PLAYLISTS'
          : 'PLAYLIST'
      ].replace(':companyId', this.companyId);
      if (_self.getPlaylistConfig.filteringBy.length) {
        initialUrl +=
          '?channel_ids=' + this.getPlaylistConfig.filteringBy.join(',');
        if (_self.getPlaylistConfig.q.length) {
          initialUrl += '&q=' + _self.getPlaylistConfig.q;
        }
      } else {
        initialUrl += '?q=' + _self.getPlaylistConfig.q;
      }
      if (_self.getPlaylistConfig.asset_list != null) {
        initialUrl += `&asset_list=${_self.getPlaylistConfig.asset_list}`;
      }
    } else {
      initialUrl = ENDPOINTS[
        _self.router.url.includes('company')
          ? 'DASHBOARD_PLAYLISTS'
          : 'PLAYLIST'
      ].replace(':companyId', this.companyId);
      this.getPlaylistConfig.filtering = false;
      this.getPlaylistConfig.q = '';
      this.getPlaylistConfig.filteringBy = [];
    }
    axios.get(initialUrl).then(response => {
      _self.initPagingVars(response);
      let url =
        ENDPOINTS[
          _self.router.url.includes('company')
            ? 'DASHBOARD_PLAYLISTS'
            : 'PLAYLIST'
        ].replace(':companyId', this.companyId) +
        '?page=' +
        _self.currentPage +
        '&per_page=' +
        _self.playlistsPerPage;
      if (_self.getPlaylistConfig.filtering) {
        if (_self.getPlaylistConfig.filteringBy.length) {
          url +=
            '&channel_ids=' + _self.getPlaylistConfig.filteringBy.join(',');
        }
        if (_self.getPlaylistConfig.q.length) {
          url += '&q=' + _self.getPlaylistConfig.q;
        }
        if (_self.getPlaylistConfig.asset_list != null) {
          url += `&asset_list=${_self.getPlaylistConfig.asset_list}`;
        }
      }
      axios.get(url).then(responseWithPaging => {
        _self.playlists = responseWithPaging.data;
        _self.generateTimeForEachPlaylist();
        _self.generateChannelForEachPlaylist();
        _self.generatePublishedDateForEachPlaylist();
      });
    });
  }

  onSearchSelect(channel) {
    if (!this.getPlaylistConfig.filteringBy.includes(channel.id)) {
      this.getPlaylistConfig.filtering = true;
      this.getPlaylistConfig.filteringBy.push(channel.id);
      this.currentPage = 1;
      this.getPlaylists();
    }
  }

  onSearchDeselect(channel) {
    if (this.getPlaylistConfig.filteringBy.includes(channel.id)) {
      this.getPlaylistConfig.filtering = true;
      this.getPlaylistConfig.filteringBy.splice(
        this.getPlaylistConfig.filteringBy.indexOf(channel.id),
        1,
      );
      this.currentPage = 1;
      this.getPlaylists();
    }
  }

  onAssetListChange() {
    switch (this.assetListFilter) {
      case 'true':
        this.getPlaylistConfig.filtering = true;
        this.getPlaylistConfig.asset_list = true;

        break;
      case 'false':
        this.getPlaylistConfig.filtering = true;
        this.getPlaylistConfig.asset_list = false;

        break;
      default:
        this.getPlaylistConfig.filtering = false;
        this.getPlaylistConfig.asset_list = null;

        break;
    }
    this.currentPage = 1;
    this.getPlaylists();
  }

  makeValidityDateInvalid(playlist) {
    playlist.invalidValidityDate = true;
  }

  makeValidityDateValid(playlist) {
    playlist.invalidValidityDate = false;
  }

  makePublishDateInvalid(playlist) {
    playlist.invalidPublishDate = true;
  }

  makePublishDateValid(playlist) {
    playlist.invalidPublishDate = false;
  }

  validateDates(playlist, publishDate: Date, validityDate: Date): boolean {
    this.makeValidityDateValid(playlist)
    this.makePublishDateValid(playlist)

    if (!publishDate) {
      this.makePublishDateInvalid(playlist)
    }

    if (!validityDate) {
      return true;
    }

    if (validityDate < publishDate) {
      this.makeValidityDateInvalid(playlist)

    } else {
      this.makeValidityDateValid(playlist)

      return true;
    }

    return false;
  }

  onDateChanged(chosenDate, playlist) {
    let publishDate = null;
    let validityDate = null;
    if (chosenDate.formatted.length) {
      publishDate = chosenDate.jsdate;

      if (playlist.validity_date) {
        validityDate = new Date(playlist.validity_date);
      }
    } else {
      playlist.published_date = null;
    }

    if (this.validateDates(playlist, publishDate, validityDate)) {
      playlist.published_date =
        chosenDate.date.year +
        '-' +
        chosenDate.date.month +
        '-' +
        chosenDate.date.day;

      this.updatePlaylist(playlist, 'published_date');
    }
  }

  onValidityDateChanged(chosenDate, playlist) {
    let publishDate = playlist.published_date ? new Date(playlist.published_date) : null;
    let validityDate = null;
    if (chosenDate.formatted.length) {
      validityDate = chosenDate.jsdate;
      if (playlist.published_date) {
        publishDate = new Date(playlist.published_date);
      }
    } else {
      playlist.expire_date = null;
    }

    if (this.validateDates(playlist, publishDate, validityDate)) {
      playlist.expire_date =
        chosenDate.date.year +
        '-' +
        chosenDate.date.month +
        '-' +
        chosenDate.date.day;

      this.updatePlaylist(playlist, 'expire');
    }
  }

  onActiveDateAdd(chosenDate, playlist) {
    if (chosenDate.formatted.length) {
      const date =
        chosenDate.date.year +
        '-' +
        chosenDate.date.month +
        '-' +
        chosenDate.date.day;

      playlist.active_dates = playlist.active_dates || [];

      playlist.active_dates.push(date);
    }
    this.updatePlaylist(playlist, 'active_dates');
  }

  generatePublishedDateForEachPlaylist() {
    for (const playlist of this.playlists) {
      if (playlist.published_date) {
        const dateObj = new Date(playlist.published_date);
        const month = dateObj.getUTCMonth() + 1;
        const day = dateObj.getUTCDate();
        const year = dateObj.getUTCFullYear();
        playlist.publishedDateModel = { date: { year, month, day } };
      }
      if (playlist.expire_date) {
        const dateObj = new Date(playlist.expire_date);
        const month = dateObj.getUTCMonth() + 1;
        const day = dateObj.getUTCDate();
        const year = dateObj.getUTCFullYear();
        playlist.validityDateModel = { date: { year, month, day } };
      }
    }
  }

  generateTodayDate() {
    const dateObj = new Date();
    const month = dateObj.getUTCMonth() + 1;
    const day = dateObj.getUTCDate();
    const year = dateObj.getUTCFullYear();
    return { date: { year, month, day } };
  }

  generateChannelForEachPlaylist() {
    for (const playlist of this.playlists) {
      playlist.selectedChannels = this.generateChannelsList(playlist.channels);
    }
  }

  toggleAllDay() {
    if (this.allDay) {
      this.fromHours = this.fromMinutes = '00';
      this.toHours = '23';
      this.toMinutes = '59';
      this.disabledTimeChooser = true;
    } else {
      this.disabledTimeChooser = false;
    }
  }

  generateChannelsList(channels) {
    const channelsList = [];
    for (const item of channels) {
      channelsList.push({
        id: item.id,
        itemName: item.name,
      });
    }
    return channelsList;
  }

  getCompanyInfo() {
    const _self = this;
    axios
      .get(ENDPOINTS.GET_COMPANIES + '/' + _self.companyId)
      .then(response => {
        _self.companyName = response.data.name;
        _self.channelsList = _self.generateChannelsList(response.data.channels);
      });
  }

  getChannels() {
    const _self = this;
    axios
      .get(ENDPOINTS.GET_CHANNELS.replace(':companyId', _self.companyId))
      .then(response => {
        _self.channelsList = _self.generateChannelsList(response.data);
      });
  }

  getUserInfo() {
    const _self = this;
    axios.get(ENDPOINTS.GET_CURRENT_USER).then(
      response => {
        _self.userRole = utilities.getUserRole(response.data);
        if (
          _self.userRole !== USER_ROLES.COMPANY_VIEWER &&
          _self.userRole !== USER_ROLES.COMPANY_EDITOR
        ) {
          _self.getCompanyInfo();
        }
        if (_self.userRole === USER_ROLES.COMPANY_EDITOR) {
          _self.dropdownSettings['hideRemoveButton'] = true;
        }
        if (_self.userRole === USER_ROLES.COMPANY_VIEWER) {
          _self.dropdownSettings['disabled'] = true;
        }
      },
      error => {},
    );
  }

  openModal(modal) {
    if (this.userRole !== 'COMPANY_VIEWER') {
      modal.open();
    }
  }

  editPlaylist(playlistId) {
    this.router.navigate([
      '/playlist-edit/' + this.companyId + '/' + playlistId,
    ]);
  }

  validateForm() {
    this.errorFields = [];
    if (!this.playlistName) {
      this.errorFields.push('playlistName');
    }
    if (typeof this.priority === 'undefined') {
      this.errorFields.push('priority');
    }
    if (!this.fromHours) {
      this.errorFields.push('fromHours');
    }
    if (!this.fromMinutes) {
      this.errorFields.push('fromMinutes');
    }
    if (!this.toHours) {
      this.errorFields.push('toHours');
    }
    if (!this.toMinutes) {
      this.errorFields.push('toMinutes');
    }
    if (!this.publishedDate) {
      this.errorFields.push('publishedDate');
    }
    if (typeof this.allDay === 'undefined') {
      this.errorFields.push('allDay');
    }
    if (typeof this.isPublished === 'undefined') {
      this.errorFields.push('isPublished');
    }
    return this.errorFields.length === 0;
  }

  connectChannels(playlistId) {
    const _self = this;
    for (const channel of _self.selectedChannels) {
      axios.post(ENDPOINTS.CHANNEL_ACCESS, {
        accessible_id: playlistId,
        accessible_type: ACCESSIBLE_CHANNEL_TYPE_PLAYLIST,
        channel_id: channel.id,
      });
    }
  }

  addNewPlaylist() {
    const _self = this;
    const playlistFormValid = this.validateForm();
    if (playlistFormValid) {
      const data = {
        name: this.playlistName,
        priority: this.priority,
        valid_from: this.fromHours + ':' + this.fromMinutes,
        valid_to: this.toHours + ':' + this.toMinutes,
        published_date:
          this.publishedDate.date.year +
            '-' +
            this.publishedDate.date.month +
            '-' +
            this.publishedDate.date.day,
        all_day: this.allDay,
        is_published: this.isPublished,
        asset_list: this.isAssetList,
      };
      axios
        .post(ENDPOINTS.PLAYLIST.replace(':companyId', this.companyId), data)
        .then(
          response => {
            _self.connectChannels(response.data.id);
            _self.playlistName = '';
            _self.priority = 0;
            _self.isPublished = false;
            _self.isAssetList = false;
            _self.allDay = false;
            _self.disabledTimeChooser = false;
            _self.fromHours = '08';
            _self.toHours = '18';
            _self.fromMinutes = _self.toMinutes = '00';
            _self.selectedChannels = [];
            _self.publishedDate = _self.generateTodayDate();
            _self.toaster.pop('success', this.playlist_added_successfully);
            _self.getPlaylists();
          },
          error => {
            _self.toaster.pop('error', this.error_adding_playlist);
          },
        );
    }
  }

  handleTableTime(time, value, playlist) {
    let parsedValue = parseInt(playlist[value], 10);
    if (time === 'hours') {
      if (isNaN(parsedValue)) {
        if (value.includes('from')) {
          parsedValue = 8;
          playlist[value] = '08';
        } else {
          parsedValue = 18;
          playlist[value] = '18';
        }
      }
      if (parsedValue < 10 && parsedValue >= 0) {
        playlist[value] = '0' + parsedValue.toString();
      }
      if (parsedValue < 0) {
        playlist[value] = '00';
      }
      if (parsedValue > 23) {
        playlist[value] = '23';
      }
    } else {
      if (isNaN(parsedValue)) {
        parsedValue = 0;
      }
      if (parsedValue < 10 && parsedValue >= 0) {
        playlist[value] = '0' + parsedValue.toString();
      }
      if (parsedValue < 0) {
        playlist[value] = '00';
      }
      if (parsedValue > 59) {
        playlist[value] = '59';
      }
    }
    const fromHours = parseInt(playlist['fromHours'], 10);
    const fromMinutes = parseInt(playlist['fromMinutes'], 10);
    const toHours = parseInt(playlist['toHours'], 10);
    const toMinutes = parseInt(playlist['toMinutes'], 10);
    if (fromHours * 60 + fromMinutes > toHours * 60 + toMinutes) {
      playlist.toHours = playlist.fromHours;
      playlist.toMinutes = playlist.fromMinutes;
    }
  }

  handleTime(time, value) {
    let parsedValue = parseInt(this[value], 10);
    if (time === 'hours') {
      if (isNaN(parsedValue)) {
        if (value.includes('from')) {
          parsedValue = 8;
          this[value] = '08';
        } else {
          parsedValue = 18;
          this[value] = '18';
        }
      }
      if (parsedValue < 10 && parsedValue >= 0) {
        this[value] = '0' + parsedValue.toString();
      }
      if (parsedValue < 0) {
        this[value] = '00';
      }
      if (parsedValue > 23) {
        this[value] = '23';
      }
    } else {
      if (isNaN(parsedValue)) {
        parsedValue = 0;
      }
      if (parsedValue < 10 && parsedValue >= 0) {
        this[value] = '0' + parsedValue.toString();
      }
      if (parsedValue < 0) {
        this[value] = '00';
      }
      if (parsedValue > 59) {
        this[value] = '59';
      }
    }
    const fromHours = parseInt(this['fromHours'], 10);
    const fromMinutes = parseInt(this['fromMinutes'], 10);
    const toHours = parseInt(this['toHours'], 10);
    const toMinutes = parseInt(this['toMinutes'], 10);
    if (fromHours * 60 + fromMinutes > toHours * 60 + toMinutes) {
      this.toHours = this.fromHours;
      this.toMinutes = this.fromMinutes;
    }
  }

  togglePlaylistAllDay(event, playlist) {
    const playlistAllDay = event.target.checked;
    if (playlistAllDay) {
      playlist.fromHours = playlist.fromMinutes = '00';
      playlist.toHours = '23';
      playlist.toMinutes = '59';
    }
    playlist.all_day = playlistAllDay;
    this.updatePlaylist(playlist, 'fromHours');
  }

  generateTimeForEachPlaylist() {
    for (let i = 0; i < this.playlists.length; i++) {
      this.playlists[i].position =
        (this.currentPage - 1) * this.playlistsPerPage + i + 1;

      const splitedTimeFrom = this.playlists[i].valid_from.split(':');
      this.playlists[i].fromHours = splitedTimeFrom[0];
      this.playlists[i].fromMinutes = splitedTimeFrom[1];

      const splitedTimeTo = this.playlists[i].valid_to.split(':');
      this.playlists[i].toHours = splitedTimeTo[0];
      this.playlists[i].toMinutes = splitedTimeTo[1];

      this.playlists[i].disabledTimeChooser = false;
    }
  }

  onItemSelect(channel, playlist) {
    if (playlist) {
      axios.post(ENDPOINTS.CHANNEL_ACCESS, {
        accessible_id: playlist.id,
        accessible_type: ACCESSIBLE_CHANNEL_TYPE_PLAYLIST,
        channel_id: channel.id,
      });
    }
  }

  OnItemDeSelect(channel, playlist) {
    if (playlist) {
      axios.delete(ENDPOINTS.CHANNEL_ACCESS, {
        data: {
          accessible_id: playlist.id,
          accessible_type: ACCESSIBLE_CHANNEL_TYPE_PLAYLIST,
          channel_id: channel.id,
        },
      });
    }
  }

  deletePlaylist(playlistId) {
    const _self = this;
    axios
      .delete(
        ENDPOINTS.PLAYLIST.replace(':companyId', this.companyId) +
          '?ids=' +
          playlistId,
      )
      .then(
        response => {
          if (this.playlists.length === 1 && this.currentPage > 0) {
            this.currentPage--;
          }
          _self.getPlaylists();
        },
        error => {},
      );
  }

  updatePlaylist(playlist, field) {
    if (field === 'name' && !playlist[field].length) {
      return;
    }
    if (
      field === 'priority' &&
      (!playlist[field].length ||
        parseInt(playlist[field], 10) < 0 ||
        parseInt(playlist[field], 10) > 10)
    ) {
      return;
    }
    if (
      field === 'fromHours' ||
      field === 'fromMinutes' ||
      field === 'toHours' ||
      field === 'toMinutes'
    ) {
      if (!playlist[field].length) {
        return;
      }
      playlist.valid_from = playlist.fromHours + ':' + playlist.fromMinutes;
      playlist.valid_to = playlist.toHours + ':' + playlist.toMinutes;
    }
    axios
      .put(
        ENDPOINTS.PLAYLIST.replace(':companyId', this.companyId) +
          '/' +
          playlist.id,
        playlist,
      )
      .then(response => {}, error => {});
  }

  playlistNameKeyDown(e: KeyboardEvent) {
    if (e.keyCode == 13 && !e.shiftKey) {
        // prevent default behavior
        e.preventDefault();
    }
  }

  public refresh() {
    this.getPlaylists();
  }

  viewSlideshow(playlistId: number) {
    //console.log(playlistId);
    window.open(
      '/slideshow/' + playlistId + '/company/' + this.companyId,
      '_blank',
    );
  }

  copyPlaylist(playlistId: string) {
    const _self = this;
    axios
      .post(
        ENDPOINTS.COPY_PLAYLIST
          .replace(':companyId', this.companyId)
          .replace(':playlistId', playlistId),
      )
      .then(
        response => {
          _self.getPlaylists();
          _self.connectChannels(response.data.id);
          _self.toaster.pop('success', this.playlist_successfully_copied);
        },
        error => {
          _self.toaster.pop('error', this.error_playlist_copied);
        },
      );
  }

}



// WEBPACK FOOTER //
// /Users/mihagresak/Documents/git-projects/vintegras-angular-new-clean/src/app/playlist-table/playlist-table.component.ts